import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { Col, Divider, Input, Row, Table, Typography } from 'antd';
import { Link, Route, Routes } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import usePresentNotifications from '../usePresentNotifications';
import DeleteModal from 'components/deleteModalView';
import EditModal from '../edit';
import { useRecoilValue } from 'recoil';
import { getPage } from '../../../../../../hooks/useUser';
import { useQuickSearch } from '../../../../../../hooks/useQuickSearch';
import FilterWrapper from '../../../../../../components/filters/wrapper';
import ShowModal from './showUpload';

const CompanyCategoriesMainPage = () => {
  const { t } = useTranslation();

  const {
    columns,
    data,
    loading,
    updateInProcess,
    onChangeTableFilter,
    handleDeleteCategory,
    form,
    premisionsGroups,
    handleCreateRole,
    onDelete,
    notifications,
    shoppingCenters,
    onUploadFile,
    handleDeleteImage,
    singleShop,
    onSaveImageNote,
  } = usePresentNotifications(true);
  const pages = useRecoilValue(getPage);
  const { onChangeTitle, filteredData, value } = useQuickSearch({
    data: data.notification_models,
  });
  return (
    <div>
      <div className={styles.container}>
        {!!data?.notification_models?.length && (
          <>
            <Row wrap={false}>
              <Col flex={1}>
                <Row gutter={[16, 16]}>
                  <Col>
                    <FilterWrapper hideClose={true} title={t('Nome')}>
                      <Input
                        placeholder={t('Nome')}
                        bordered={false}
                        onChange={onChangeTitle}
                        value={value}
                      />
                    </FilterWrapper>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Divider />
            <Table
              columns={columns}
              // dataSource={data.notification_models}
              dataSource={filteredData}
              pagination={data.pagination}
              onChange={onChangeTableFilter}
              loading={loading}
            />
          </>
        )}
        {!data?.notification_models?.length && (
          <Row className={styles.emptyRow} justify={'center'}>
            <div className={styles.actionIcon}>
              <SearchOutlined />
            </div>
            <Typography.Title level={4}>
              {t('Non hai notifiche')}
            </Typography.Title>
            <Typography className={styles.textNew} color='red'>
              {t('Сrea ora una nuova notifica')}
            </Typography>
            <Link to={'create/new'}>
              <Button width={'173px'} big icon={<PlusOutlined />}>
                {t('Un nuovo notifiche')}
              </Button>
            </Link>
          </Row>
        )}
      </div>
      <Routes>
        <Route
          path={'image'}
          element={
            <ShowModal
              loading={loading}
              item={singleShop}
              onUploadFile={onUploadFile}
              handleDeleteImage={handleDeleteImage}
              onSaveImageNote={onSaveImageNote}
            />
          }
        />
        <Route
          path={'new'}
          element={
            <EditModal
              shoppingCenters={shoppingCenters}
              notifications={notifications}
              form={form}
              onClickDelete={handleDeleteCategory}
              loading={updateInProcess}
              premisionsGroups={premisionsGroups}
              handleCreateRole={handleCreateRole}
            />
          }
        />
        <Route
          path={'edit'}
          element={
            <EditModal
              shoppingCenters={shoppingCenters}
              notifications={notifications}
              form={form}
              onClickDelete={handleDeleteCategory}
              loading={updateInProcess}
              premisionsGroups={premisionsGroups}
              handleCreateRole={handleCreateRole}
            />
          }
        />
        <Route
          path={'delete'}
          element={
            <DeleteModal onClickDelete={onDelete} loading={updateInProcess} />
          }
        />
      </Routes>
    </div>
  );
};

export default CompanyCategoriesMainPage;
